export function shouldDisplayPeOrCombinedPeStampButton(isStaff: boolean) {
    return isStaff;
  }